// src/pages/Stories.jsx
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";


const Stories = () => {
  return (
    <div className="container my-5">
      <h1 className="text-center mb-5">Our Stories</h1>

    
    </div>
  );
};

export default Stories;